import React from 'react';
import { UserSearchResult, UserTypeahead } from './UserTypeahead';

function formatUserLabel(user: UserSearchResult): string {
  const name = [user.firstName, user.lastName].filter(Boolean).join(' ').trim();
  return name ? `${name} (${user.email})` : user.email;
}

export const NotificationUserSelect: React.FC<{
  selectedUsers: UserSearchResult[];
  onSelect: (user: UserSearchResult) => void;
  onRemove: (userId: string) => void;
}> = ({ selectedUsers, onSelect, onRemove }) => {
  return (
    <div className="grid gap-3">
      <UserTypeahead onSelect={onSelect} placeholder="Search and add users by name or email" />
      {selectedUsers.length > 0 ? (
        <div className="grid gap-2">
          {selectedUsers.map((user) => (
            <div key={user.id} className="flex items-start justify-between gap-3 rounded-xl border border-gray-200 bg-gray-50 px-4 py-3">
              <div>
                <div className="text-sm font-semibold text-gray-900">{formatUserLabel(user)}</div>
                <div className="mt-1 text-xs text-gray-500">User ID: {user.id}</div>
              </div>
              <button
                type="button"
                className="rounded-lg bg-white px-3 py-2 text-xs font-semibold text-gray-700 ring-1 ring-gray-200 hover:bg-gray-100"
                onClick={() => onRemove(user.id)}
              >
                Remove
              </button>
            </div>
          ))}
        </div>
      ) : (
        <div className="rounded-xl border border-dashed border-gray-300 bg-gray-50 px-4 py-3 text-sm text-gray-500">
          No users selected yet.
        </div>
      )}
    </div>
  );
};
